import type { ButtonHTMLAttributes } from "react";

import { cn } from "./cn";

export type ChipVariant = "filter" | "today" | "system" | "success";

const VARIANT: Record<ChipVariant, string> = {
  filter: "bg-sunken text-fg-muted",
  today: "bg-accent-subtle text-accent-fg",
  system: "bg-system-subtle text-system-fg",
  success: "bg-success-bg text-success",
};

export function Chip({
  variant = "filter",
  selected = false,
  className,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ChipVariant;
  selected?: boolean;
}) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      className={cn(
        "tap-target inline-flex h-8 shrink-0 items-center whitespace-nowrap rounded-full px-3.5 text-footnote font-medium",
        "transition-[transform,background-color] motion-fast active:scale-[0.97] [@media(prefers-reduced-motion:reduce)]:active:scale-100",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus",
        VARIANT[variant],
        selected && "bg-accent text-on-accent",
        className,
      )}
      {...props}
    />
  );
}
